import type { Dictionary } from '@/i18n/dictionary'

export interface ContactValues {
  name: string
  email: string
  company: string
  message: string
  consent: boolean
}

export type ContactField = keyof ContactValues

export type ContactErrors = Partial<Record<ContactField, string>>

export const MESSAGE_MIN_LENGTH = 20

const EMAIL_PATTERN = /^[^\s@]+@[^\s@.]+(?:\.[^\s@.]+)+$/

export const emptyContactValues: ContactValues = {
  name: '',
  email: '',
  company: '',
  message: '',
  consent: false,
}

export const validateContact = (values: ContactValues, dictionary: Dictionary): ContactErrors => {
  const messages = dictionary.contact.form.errors
  const errors: ContactErrors = {}

  if (values.name.trim().length === 0) errors.name = messages.nameRequired

  const email = values.email.trim()
  if (email.length === 0) errors.email = messages.emailRequired
  else if (!EMAIL_PATTERN.test(email)) errors.email = messages.emailInvalid

  const message = values.message.trim()
  if (message.length === 0) errors.message = messages.messageRequired
  else if (message.length < MESSAGE_MIN_LENGTH) errors.message = messages.messageTooShort

  if (!values.consent) errors.consent = messages.consentRequired

  return errors
}

export const buildMailBody = (values: ContactValues): string =>
  [
    values.name,
    values.email,
    values.company.trim().length > 0 ? values.company : undefined,
    '',
    values.message,
  ]
    .filter((line) => line !== undefined)
    .join('\n')
